import React from "react";
import { Edit2, Trash2 } from "lucide-react";

const IndexRow = ({ speaker }) => (
  <>
    {/* Kolom 1: Name & Image - DISAMAKAN DENGAN USER */}
    <td className="px-6 py-4 rounded-l-xl">
      <div className="flex items-center gap-3">
        <img 
          src={speaker.image} 
          alt={speaker.name} 
          className="w-10 h-10 rounded-full object-cover border border-stone-200" 
        />
        <div>
          <p className="text-xs font-black text-stone-800 dark:text-white uppercase tracking-tight">
            {speaker.name}
          </p>
          <p className="text-[10px] text-stone-400 font-medium">Speaker ID: {speaker.id}</p>
        </div>
      </div>
    </td>

    {/* Kolom 2: Title - DISAMAKAN DENGAN USER ROLE */}
    <td className="px-4 py-4 text-[10px] font-black uppercase tracking-widest text-stone-600 dark:text-stone-300">
      {speaker.title}
    </td>

    {/* Kolom 3: Topic - DISAMAKAN DENGAN USER STATUS (Centered) */}
    <td className="px-4 py-4 text-center">
      <span className="px-3 py-1 rounded-full text-[9px] font-black uppercase tracking-tighter bg-blue-50 text-blue-600 border border-blue-100">
        {speaker.topic}
      </span>
    </td>

    {/* Kolom 4: Degree - DISAMAKAN DENGAN JOINED DATE (Centered) */}
    <td className="px-4 py-4 text-center text-xs font-medium text-stone-500">
      {speaker.degree}
    </td>

    {/* Kolom 5: Actions - DISAMAKAN DENGAN USER ACTIONS */}
    <td className="px-6 py-4 rounded-r-xl">
      <div className="flex items-center justify-center gap-2">
        <button className="p-2.5 bg-white/50 hover:bg-blue-100 text-stone-400 hover:text-blue-600 rounded-xl transition-all shadow-sm">
          <Edit2 size={14} />
        </button>
        <button className="p-2.5 bg-white/50 hover:bg-red-100 text-stone-400 hover:text-red-600 rounded-xl transition-all shadow-sm">
          <Trash2 size={14} />
        </button>
      </div>
    </td>
  </>
);

export default IndexRow;